/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["osa",[["AM","PM"]],u,[["𐓏","𐓄","𐓍","𐒴","𐓈","𐓊","𐓸"],["𐒹𐓘͘𐓬𐓘 𐓏𐓘𐓤𐓘͘𐓰𐓘𐓤𐓣","𐒹𐓘͘𐓬𐓘 𐓄𐓘𐓡𐓛͘𐓧𐓣","𐒹𐓘͘𐓬𐓘 𐓏𐓟𐓵𐓪͘𐓬𐓘","𐒹𐓘͘𐓬𐓘 𐓏𐓟𐓵𐓘𐓜𐓣","𐒹𐓘͘𐓬𐓘 𐓏𐓟𐓰𐓪𐓬𐓘","𐒹𐓘͘𐓬𐓘 𐓈𐓘 𐓵𐓘𐓲𐓘 𐓻𐓣͘","𐒹𐓘͘𐓬𐓘 𐓂𐓤𐓘𐓸𐓟 𐓣͘𐓤𐓟"]],[["S","M","T","W","T","F","S"],["𐒹𐓘͘𐓬𐓘 𐓏𐓘𐓤𐓘͘𐓰𐓘𐓤𐓣","𐒹𐓘͘𐓬𐓘 𐓄𐓘𐓡𐓛͘𐓧𐓣","𐒹𐓘͘𐓬𐓘 𐓏𐓟𐓵𐓪͘𐓬𐓘","𐒹𐓘͘𐓬𐓘 𐓏𐓟𐓵𐓘𐓜𐓣","𐒹𐓘͘𐓬𐓘 𐓏𐓟𐓰𐓪𐓬𐓘","𐒹𐓘͘𐓬𐓘 𐓈𐓘 𐓵𐓘𐓲𐓘 𐓻𐓣͘","𐒹𐓘͘𐓬𐓘 𐓂𐓤𐓘𐓸𐓟 𐓣͘𐓤𐓟"]],[["1","2","3","4","5","6","7","8","9","10","11","12"],["𐓄𐓘𐓡𐓛͘𐓧𐓟","𐓵𐓪͘𐓬𐓘","𐓵𐓘𐓜𐓣","𐓰𐓪𐓬𐓘","𐓮𐓘𐓰𐓘","𐓯𐓘𐓬𐓟","𐓄𐓟𐓵𐓪͘𐓬𐓘","𐒼𐓣𐓟𐓰𐓪𐓬𐓘","𐒿𐓟𐓜𐓛𐓲𐓟𐓷𐓣͘𐓤𐓟","𐒿𐓟𐓜𐓛","𐒰𐓧𐓣 𐓏𐓣͘𐓸𐓲𐓣","𐒰𐓧𐓣 𐓍𐓪͘𐓬𐓘"],["𐓀𐓣͘𐓪͘𐓬𐓘 𐓄𐓘𐓡𐓛͘𐓧𐓟","𐓀𐓣͘𐓪͘𐓬𐓘 𐓏𐓟𐓵𐓪͘𐓬𐓘","𐓀𐓣͘𐓪͘𐓬𐓘 𐓏𐓟𐓵𐓘𐓜𐓣","𐓀𐓣͘𐓪͘𐓬𐓘 𐓏𐓟𐓰𐓪𐓬𐓘","𐓀𐓣͘𐓪͘𐓬𐓘 𐓏𐓟𐓮𐓘𐓰𐓘","𐓀𐓣͘𐓪͘𐓬𐓘 𐓏𐓟𐓯𐓘𐓬𐓟","𐓀𐓣͘𐓪͘𐓬𐓘 𐓄𐓟𐓵𐓪͘𐓬𐓘","𐓀𐓣͘𐓪͘𐓬𐓘 𐒼𐓣𐓟𐓰𐓪𐓬𐓘","𐓀𐓣͘𐓪͘𐓬𐓘 𐒿𐓟𐓜𐓛𐓲𐓟𐓷𐓣͘𐓤𐓟","𐓀𐓣͘𐓪͘𐓬𐓘 𐒿𐓟𐓜𐓛","𐓀𐓣͘𐓪͘𐓬𐓘 𐒰𐓧𐓣 𐓏𐓣͘𐓸𐓲𐓣","𐓀𐓣͘𐓪͘𐓬𐓘 𐒰𐓧𐓣 𐓍𐓪͘𐓬𐓘"]],u,[["BCE","CE"]],0,[6,0],["y-MM-dd","y MMM d","y MMMM d","y MMMM d, EEEE"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤ #,##0.00","#E0"],"USD","$",u,{"JPY":["JP¥","¥"]},"ltr", plural];
